<template>
  <v-dialog hide-overlay max-width="800px" v-model="show">
    <v-card>
      <v-card-title>決裁番号入力</v-card-title>
      <v-card-actions>
        <v-btn @click="save()">保存</v-btn>
        <v-btn @click="show = false">戻る</v-btn>
      </v-card-actions>
      <v-container fluid>
        <div class="card-text">
          <v-text-field label="決裁番号" v-model="sjlApprovalNo"></v-text-field>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return { show: false, sjlApprovalNo: null, shipment: {} }
  },
  methods: {
    close() {
      this.$emit('closeEvent', false)
    },
    popup(shipment) {
      this.show = true
      this.shipment = shipment
    },
    save() {
      this.$http
        .put(
          `/quotations/update-sjl-approval-no/${this.shipment.id}?sjlApprovalNo=${this.sjlApprovalNo}`
        )
        .then(() => {
          this.$message('', 'SUCCESS')
          this.show = false
        })
    },
  },
}
</script>

<style>
.select-area {
  border: 2px solid #000;
  height: 300px;
}

.card-text {
  padding: 0px 10px;
}
</style>
